import http from './api'

const url = '/admin_data/helptexts'

export const httpGetHelptexts = () => {
  return http({
    url: `${url}/`,
    method: 'GET',
  })
}